import { Button, Text } from '@chakra-ui/react'
import { generatePath, useNavigate } from 'react-router'
import {
  StaticScreen,
  StaticScreenTitle,
  StaticScreenContent,
  StaticScreenFooter,
} from 'src/components/StaticScreen/StaticScreen'
import { Paths } from 'src/constants/paths'
import { useSelectedTrial } from 'src/features/auth/context'

export const NotFoundMessageScreen: React.FC = () => {
  const { selectedTrial } = useSelectedTrial()
  const navigate = useNavigate()

  return (
    <StaticScreen>
      <StaticScreenTitle>ファイルが見つかりません</StaticScreenTitle>
      <StaticScreenContent>
        <Text>
          対象のファイルにアクセス権がないか、ファイルが削除された可能性があります。
        </Text>
      </StaticScreenContent>
      <StaticScreenFooter>
        <Button
          onClick={() =>
            navigate(
              generatePath(Paths.TrialTop, { trialUid: selectedTrial.uid }),
            )
          }
        >
          試験TOP画面へ
        </Button>
      </StaticScreenFooter>
    </StaticScreen>
  )
}
